import { Image } from '@/components/client';
import { getStaticCdnUrl } from '@/utils';
import { checkTodayInRange } from '@/utils/checkTodayInRange';

const NOTICE_IMAGE_URL = getStaticCdnUrl(
  'donation/delivery-notice-chuseok.png',
);

/** 원본 자산 픽셀 크기 — 슬롯 비율이 여기서 파생되므로 자산 교체 시 함께 갱신한다 */
const NOTICE_IMAGE_WIDTH = 3_240;
const NOTICE_IMAGE_HEIGHT = 4_206;

const NOTICE_START_AT = '2026-09-21T00:00:00+09:00';
const NOTICE_END_AT = '2026-09-28T23:59:59+09:00';

export const DeliveryNoticeImage = () => {
  if (!checkTodayInRange(NOTICE_START_AT, NOTICE_END_AT)) {
    return null;
  }

  return (
    <Image
      src={NOTICE_IMAGE_URL}
      alt="9월 추석연휴 배송 안내. 9월 24일(목)부터 27일(일)까지 택배사가 휴무이며, 9월 28일(월)부터 순차 출고됩니다. 휴무 전일인 9월 23일(수) 주문 건은 9월 28일(월)부터 순차적으로 출고되며, 연휴 이후 택배 물량 증가로 배송이 지연될 수 있습니다."
      width={NOTICE_IMAGE_WIDTH}
      height={NOTICE_IMAGE_HEIGHT}
      className="h-auto w-full"
      sizes="(max-width: 768px) 100vw, 850px"
    />
  );
};
